export default "__VITE_ASSET__2yiy_56g__"